import styled, { css } from 'styled-components'
import { maxWidth, noTouch } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'

const Accordion = styled.div`
  position: relative;
  border: 1px solid rgba(var(--color-border-rgb), 0.5);

  .ReactCollapse--collapse {
    transition: height 500ms;
  }

  & + & {
    border-top: none;
  }

  ${props =>
    props.open &&
    css`
      ${Accordion.Toggle} {
        color: var(--color-decor)
      }
      ${Accordion.Toggle}::after {
        border-top-color: var(--color-decor);
        transform: rotate(-90deg);
      }

      ${Accordion.Content} {
        transform: none;
        opacity: 1;
      }
    `}
`

Accordion.Toggle = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 29px 54px 29px 29px;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: left;
  cursor: pointer;
  transition: color 0.25s ease-out;

  &::after {
    content: '';
    position: absolute;
    top: 34px;
    right: 30px;
    display: block;
    width:9px;
    height:16px;
    background-image: url("data:image/svg+xml,%3Csvg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.740209 0.74026L7.99995 8L0.740209 15.2597' stroke='%23B69B64'/%3E%3C/svg%3E ");
    background-repeat:no-repeat;
    background-position:center;    
    transition: border-color 0.3s ease-out, transform 0.3s ease-out;
  }

  ${noTouch()`
    &:hover {
      color: var(--color-decor);

      &::after {
        border-top-color: var(--color-decor);
      }
    }
  `}

  ${maxWidth(vars.breakpoints.tablet)`
    padding: 19px 46px 20px 20px;
    font-size: 14px;

    &::after {
      top: 27px;
      right: 20px;
    }
  `}
`

Accordion.Content = styled.div`
  padding: 0 29px 29px;
  font-size: 16px;
  line-height: 1.6;
  color: #000;
  opacity: 0;
  transform: translateY(-10px);
  transition: 0.3s ease-out;

  ${maxWidth(vars.breakpoints.tablet)`
    font-size: 14px;
  `}
`

export default Accordion
